document.addEventListener("DOMContentLoaded", () => {
  const button = document.getElementById("header-menu-button");
  const menu = document.getElementById("header-menu");

  menu.setAttribute("aria-expanded", false);
  button.setAttribute("aria-expanded", false);

  button.onclick = () => {
    const newValue = button.getAttribute("aria-expanded") === "false";
    document.body.classList.toggle("menu-expanded", newValue);
    document.body.classList.toggle("menu-collapsed", !newValue);
    button.setAttribute("aria-expanded", newValue);
    menu.setAttribute("aria-expanded", newValue);
  };
});
